// extracted by mini-css-extract-plugin
export default {"ConsentManagerTable":"ConsentManager_ConsentManagerTable__gNq9q"};